import * as Types from '@/types'

/**
 * 支持的结算方式
 * 2: 到付现结
 * 3: 寄付
 */
export type SettlementMode = 1 | 2 | 3

export const CASH_ON_DELIVERY = 2
export const DELIVERY_SETTLE = 3

export const PAY_TYPE: Types.DictLabel<SettlementMode> = {
  1: 'newOder.payNow',
  2: 'newOder.cashOnDelivery',
  3: 'constant.deliverySettle',
}

/** 个人用户与企业用户公用 */
export const PAYTYPE_OPTIONS = [
  {
    label: 'newOder.cashOnDelivery',
    value: 2,
    disabled: true,
  },
  {
    label: 'constant.deliverySettle',
    value: 3,
    disabled: false,
  },
]

export const DEFAULT_PAYMENT_OPTIONS = {
  2: true,
  3: false,
}
